"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteShippingKit = void 0;
const common_1 = require("../../common");
class DeleteShippingKit extends common_1.UpdateAction {
}
exports.DeleteShippingKit = DeleteShippingKit;
//# sourceMappingURL=delete-shipping-kit.action.js.map